import { PaymentProfile } from "../pages/companyProfile/PaymentDetails";
import { CompanyPaymentDetails } from "../pages/companyProfile/PaymentDetailsDialog";
import optionsApi from "./optionsApi";

export async function createCompanyPayment(
  data: Partial<CompanyPaymentDetails>
): Promise<CompanyPaymentDetails> {
  return optionsApi
    .post("v2/payment/createCompanyPayment", data)
    .then((res) => res.data.data);
}

export async function updateCompanyPayment(
  data: Partial<CompanyPaymentDetails>
): Promise<CompanyPaymentDetails> {
  return optionsApi
    .put("v2/payment/editCompanyPayment", data)
    .then((res) => res.data.data);
}

export async function getCompanyPaymentDetails(): Promise<CompanyPaymentDetails> {
  return optionsApi
    .get("v2/payment/getCompanyPaymentDetails")
    .then((res) => res.data.data);
}
export async function getCompanyPaymentProfiles(): Promise<PaymentProfile[]> {
  return optionsApi
    .get("v2/payment/getCompanyPaymentProfiles")
    .then((res) => res.data.data);
}

export async function createPaymentProfile(
  data: Partial<CompanyPaymentDetails>
): Promise<CompanyPaymentDetails> {
  return optionsApi
    .post("v2/payment/createPaymentProfile", data)
    .then((res) => res.data.data);
}
